/**
 * Sticky-CTA корзины (design-guest v7 §10/§11): «Перейти к заказу · N
 * позиций · {total} ₽» — появляется поверх контента, когда в корзине есть
 * позиции, ведёт в §12 (/menu/order). Намеренно НЕ модалка и НЕ отдельный
 * экран-список: это кнопка-переход к корзине (исключение из правила форм).
 */
import { useNavigate } from 'react-router-dom';
import { formatPriceMinor } from '@hsc/types';
import type { UseCart } from './useCart.js';

/** Русское склонение «N позиция/позиции/позиций». */
function pluralItems(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} позиция`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${n} позиции`;
  return `${n} позиций`;
}

export function GuestCartCta({
  locale,
  cart,
}: {
  locale: string;
  cart: UseCart;
}): JSX.Element | null {
  const navigate = useNavigate();
  if (cart.count === 0) return null;

  const total =
    cart.currency !== undefined
      ? ` · ${formatPriceMinor(cart.totalMinor, cart.currency, locale)}`
      : '';

  return (
    <div className="fnb-cta-wrap">
      <button
        type="button"
        className="fnb-cta"
        data-testid="cart-cta"
        onClick={() => navigate('/menu/order')}
      >
        Перейти к заказу · <span data-testid="cart-count">{pluralItems(cart.count)}</span>
        <span data-testid="cart-total">{total}</span>
      </button>
    </div>
  );
}
